export default IconNumber11Small => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-number-11-small" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 10l2 -2v8" />
  <path d="M14 10l2 -2v8" />
</svg>`;